import React from 'react'
import { useAuth } from '../../context/authContext'
import { Button, Loader } from 'semantic-ui-react'
import "./ReproductorDescargas.scss"

function ReproductorDescargas({url}) {

    const [loading,setLoading]=React.useState(true)

    React.useEffect(()=>{
        setTimeout(()=>{
            setLoading(false)

        },800)

    },[])

  return (
    <div className='containerReproductorDescargas' >
        <div className="playerDescargas" >
            {
                loading&& (
                    <Loader active inline content="cargando..." className='LoadingDescargas'  />
                )
                
            }

                    <iframe  
                    allowFullScreen
                    frameBorder="0"
                    marginHeight="0"
                    marginWidth="0"
                    scrolling="none"
                    className='iframeDescarga'
                        
                    src={url}  ></iframe>
                
        </div>
    </div>
  )
}

export default ReproductorDescargas